// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"UserRegistrationModal-dc57c3f17a231809","link":"UserRegistrationModal-ad90c098a60589ec"};